import { render, staticRenderFns } from "./NewMessageModal.vue?vue&type=template&id=5af978f0&scoped=true&"
import script from "./NewMessageModal.vue?vue&type=script&lang=js&"
export * from "./NewMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./NewMessageModal.vue?vue&type=style&index=0&id=5af978f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af978f0",
  null
  
)

export default component.exports